import React, { useState } from 'react';

import { observer } from 'mobx-react-lite';
import { ModalTitle } from '@trader/components';
import { useMst } from '@trader/store';
import { useI18next } from '@trader/services';

import { AccountStatementReport } from './components/accountStatementReport';
import * as Styled from './styled';

export const AccountStatement: React.FC = observer(() => {
  const store = useMst();
  const { translate } = useI18next();
  const nowDate = new Date().toISOString().split('T')[0];
  const [fromDate, setFromDate] = useState(nowDate);
  const [toDate, setToDate] = useState(nowDate);
  const [isAccountStatement, setIsAccountStatement] = useState(false);
  const platformLogin = store.ui.modal.options.get('platformLogin');
  const product = store.ui.modal.options.get('product');
  const accountType = store.ui.modal.options.get('accountType');
  const accountCurrency = store.ui.modal.options.get('tradingAccountCurrency');

  const handleFromDateChange = event => {
    setFromDate(event.target.value);
  };
  const handleToDateChange = event => {
    setToDate(event.target.value);
  };

  const handleGenerateReport = () => {
    setIsAccountStatement(true);
  };

  const isValidDate = date => {
    return date !== null && date !== '';
  };

  return (
    <>
      {isAccountStatement ? (
        <Styled.Root height={700} width={1000}>
          <ModalTitle title={translate('COMMON.LABELS.ACCOUNT_STATEMENT')} />
          <AccountStatementReport
            from={fromDate}
            to={toDate}
            platformLogin={platformLogin}
            currency={accountCurrency}
            product={product}
            accountType={accountType}
          />
        </Styled.Root>
      ) : (
        <Styled.Root width={270}>
          <ModalTitle title={translate('COMMON.LABELS.SELECT_REPORT_PERIOD')} />
          <Styled.Content>
            <Styled.Label>{translate('COMMON.LABELS.FROM')}:</Styled.Label>
            <Styled.Input
              type='date'
              value={fromDate}
              max={toDate}
              onChange={handleFromDateChange}
            />
            {isValidDate(fromDate) ? (
              ''
            ) : (
              <Styled.Error>
                {translate('COMMON.ERRORS.FROM_DATE_IS_REQUIRED')}
              </Styled.Error>
            )}

            <Styled.Label>{translate('COMMON.LABELS.TO')}:</Styled.Label>
            <Styled.Input
              type='date'
              value={toDate}
              min={fromDate}
              max={nowDate}
              onChange={handleToDateChange}
            />
            {isValidDate(toDate) ? (
              ''
            ) : (
              <Styled.Error>
                {translate('COMMON.ERRORS.TO_DATE_IS_REQUIRED')}
              </Styled.Error>
            )}
            <Styled.ActionButton
              disabled={fromDate === '' || toDate === ''}
              onClick={handleGenerateReport}
            >
              {translate('COMMON.LABELS.GENERATE')}
            </Styled.ActionButton>
          </Styled.Content>
        </Styled.Root>
      )}
    </>
  );
});
